import * as login from '../../constants/login'

export default (state = {}, action) => {
    switch (action.type) {
        case login.LOGIN_FETCH_OPERATOR_INFO:
            return { ...state, operatorInfo: action.payload.operator }
        case login.LOGIN_SET_SESSION_OBJ:
            return { ...state, session: action.payload.session }
        default:
            return state;
    }
}